/**
 * v4.10.0 — Tiny `?` glyph that re-opens a dismissed Setup Guidance card.
 *
 * Subtle, contextual, sits in page headers. No floating widgets, no badges,
 * no surface that competes with operational content.
 */
import { useTranslation } from "react-i18next";
import { HelpCircle } from "lucide-react";
import { resetSetupGuide } from "./useSetupGuide";

export const HelpGlyph = ({ guideKey, testId }) => {
    const { t } = useTranslation();
    const onClick = () => resetSetupGuide(guideKey);
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={t("setup_guide.show_help")}
            title={t("setup_guide.show_help")}
            data-testid={testId || `help-glyph-${guideKey}`}
            className="inline-flex items-center justify-center w-6 h-6 rounded-full text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
        >
            <HelpCircle size={14} strokeWidth={1.75} />
        </button>
    );
};

export default HelpGlyph;
